import React, { useState } from "react";
import ReactModal from "react-modal";
import ImageUploading from "react-images-uploading";
import { useDispatch } from "react-redux";
import { Create_Post, GetAllPost } from "../../../actions/auth";
import swal from "sweetalert";
import imageCompression from "browser-image-compression";

const ModalPostCommunity = (propsID) => {
  const [isEditMode2, setIsEditMode2] = useState(false);
  const [modalIsOpen2, setModalIsOpen2] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [description, setDescription] = useState("");
  const [DescErr, setDescErr] = useState("");
  // const [post_id, setPost_id] = useState("");

  const dispatch = useDispatch("");

  const allowedFormats = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/heic",
  ];

  const [images, setImages] = useState([]);
  const [imagesfile, setImagesfile] = useState([]);
  const [imgErrs, setImgErrs] = useState("");
  const maxNumber = 5; // Maximum number of images
  const maxFileSize = 25 * 1024 * 1024; // 25MB limit // Maximum file size: 5MB
  const [list, setList] = useState([]); // State to hold API data

  const maxImages = 5;

  const onChange = async (imageList, addUpdateIndex) => {
    console.log(imageList, "imageList....");

    if (imageList.length === 0) {
      setImages(imageList);
      setImagesfile([]);
      setImgErrs("Please upload an image. This field cannot be left blank.");
      return;
    }

    // Validate maximum number of images
    if (imageList.length > maxImages) {
      setImgErrs(
        "You can upload a maximum of 5 images. Please remove additional files."
      );
      return;
    }

    // Provide immediate feedback by setting images
    setImages(imageList);

    // Asynchronously compress images
    const compressImages = async (images) => {
      const compressedImages = await Promise.all(
        images.map(async (image) => {
          try {
            const compressedFile = await imageCompression(image.file, {
              maxSizeMB: 5, // Adjusted size for faster compression
              maxWidthOrHeight: 1280, // Adjusted dimensions for faster processing
              useWebWorker: true,
            });
            return { ...image, file: compressedFile };
          } catch (error) {
            console.error("Error compressing image:", error);
            return image; // Return original image if compression fails
          }
        })
      );

      // Validate each image
      const invalidFiles = compressedImages.filter((image) => {
        const file = image.file;
        return (
          !file.type ||
          file.size > maxFileSize || // Exceeds max size
          !allowedFormats.includes(file.type) // Invalid format
        );
      });

      if (invalidFiles.length > 0) {
        const errorMessages = invalidFiles.map((image) => {
          const file = image.file;
          if (file.size > maxFileSize) {
            return `The uploaded file size cannot exceed 25 MB. (${file.name})`;
          }
          if (!allowedFormats.includes(file.type)) {
            return `Invalid image format. Please upload a (JPG, PNG, JPEG, or HEIC).`;
          }
          return null;
        });
        setImgErrs(errorMessages.join(" "));
        return;
      }

      // If validation passes
      setImages(compressedImages);
      const imageFiles = compressedImages.map((image) => image?.file);
      console.log(imageFiles, "imageFiles...");
      setImagesfile(imageFiles);

      setImgErrs(""); // Clear errors
    };

    // Start compression asynchronously
    compressImages(imageList);
  };

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  const [error, setError] = React.useState("");

  const handleRemoveAll = () => {
    setImages([]); // Clear all selected images
    setError(""); // Clear any error messages
  };

  const validateDescription = (value) => {
    if (value.trim() === "") {
      setDescErr("Description cannot be blank. Please provide details.");
    } else if (value.length < 2) {
      setDescErr("Description must be at least 2 characters long.");
    } else if (value.length > 500) {
      setDescErr("Description cannot exceed 500 characters.");
    } else if (!/^[a-zA-Z0-9\s.,!?'"’‘"\-]*$/.test(value)) {
      setDescErr(
        "Invalid description. Only letters, numbers, spaces, and common punctuation are allowed."
      );
    } else {
      setDescErr(""); // Clear the error if the value is valid
    }
  };
  const handleChange = (event) => {
    const value = event.target.value;
    setDescription(value.trimStart()); // Update description state
    validateDescription(value); // Validate description on change
  };

  // Add new loading state
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    if (!description) {
      setDescErr("Description cannot be blank. Please provide details.");
    }
    if (images.length == 0) {
      setImgErrs("Please upload an image. This field cannot be left blank.");
    } else {
      const invalidFiles = images.filter((image) => {
        const file = image.file;
        return (
          !file.type ||
          file.size > maxFileSize || // Exceeds max size
          !allowedFormats.includes(file.type) // Invalid format
        );
      });

      if (invalidFiles.length > 0) {
        const errorMessages = invalidFiles.map((image) => {
          const file = image.file;
          if (file.size > maxFileSize) {
            return `The uploaded file size cannot exceed 25 MB. (${file.name})`;
          }
          if (!allowedFormats.includes(file.type)) {
            return `Invalid image format. Please upload a (JPG, PNG, JPEG, or HEIC).`;
          }
          return null;
        });
        setImgErrs(errorMessages.join(" "));
        return; // Stop submission
      } else {
        setImgErrs(""); // Clear image errors
      }
    }
    // else {
    //   setImgErrs("");
    // }
    const userrole =
      localStorage.getItem("Role_user_Auth") == 2 ? "admin" : "super_admin";
    const formData = new FormData();
    imagesfile.forEach((file, index) => {
      formData.append(`images`, file); // The backend will receive it as `req.files`
    });
    formData.append("message", description);
    formData.append("community_id", propsID?.id);
    formData.append("user_type", userrole);
    console.log(propsID, "propsID......");

    if (images && description && propsID?.id && !imgErrs && !DescErr) {
      setIsLoading(true); // Start loading
      dispatch(Create_Post(formData))
        .then((e) => {
          if (e?.success == true) {
            swal("", "Post added successfully", "success");
            setModalIsOpen2(false);
            setDescription("");
            setImages([]);
            setImagesfile([]);
            if (propsID.onPostCreated) {
              propsID.onPostCreated();
            }
          }
          setIsLoading(false); // Stop loading regardless of result
        })
        .catch(() => {
          setIsLoading(false); // Stop loading on error
        });
    }
  };

  const openModalPost = (isEdit = false, radar = null) => {
    setIsEditMode2(isEdit);
    // if (isEdit && radar) {
    //   setCity(radar.city);
    //   setSelectedRadarId(radar?._id);
    // } else {
    //   setCity("");
    //   setSelectedRadarId(null);
    // }
    setModalIsOpen2(true);
  };
  const closeModalPost = () => {
    setModalIsOpen2(false);
    setDescErr("");
    setDescription("");
    setImages("");
    setImgErrs("");
    setErrorMessage("");
    // setError("");
    // document.body.style.overflow = "auto";
  };

  return (
    <>
      <ReactModal
        isOpen={modalIsOpen2}
        style={{
          overlay: {
            background: "rgba(0, 0, 0, .50)",
            zIndex: "999",
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            minWidth: "570px",
            border: "none",
            padding: "0px",
            animation: "pop-up 0.5s forwards",
            overflow: "hidden",
          },
        }}
      >
        {/* Add loader */}
        {isLoading && (
          <div className="loader-container mt-5">
            <div className="loaderss"></div>
          </div>
        )}
        <div className="modal-header pb-3">
          <h6 className="modal-title">Add New Post</h6>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModalPost}
          ></button>
        </div>
        <div className="modal-content border-0">
          <div className="modal-body">
            <div className="mb-2">
              {" "}
              <label className="text-black fw-bold">Upload Images</label>
            </div>
            <div
              style={{
                maxWidth: "600px",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              <ImageUploading
                multiple
                value={images}
                onChange={onChange}
                // maxNumber={maxNumber}
                dataURLKey="data_url"
              >
                {({
                  imageList,
                  onImageUpload,
                  onImageRemoveAll,
                  // onImageRemove,
                  dragProps,
                }) => (
                  <div
                    style={{
                      border: "2px dashed #ccc",
                      padding: "20px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      // marginBottom: "20px",
                      textAlign: "center",
                    }}
                    onClick={onImageUpload}
                    {...dragProps}
                  >
                    {imageList.length === 0 && (
                      <p style={{ color: "#888", margin: 0 }}>
                        Click or Drag & Drop to upload images
                      </p>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      {imageList.map((image, index) => (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            display: "inline-block",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={image["data_url"]}
                            alt=""
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                            }}
                          />
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              const updatedImages = images.filter(
                                (_, idx) => idx !== index
                              );
                              setImages(updatedImages);

                              if (updatedImages.length === 0) {
                                setImgErrs(
                                  "Please upload an image. This field cannot be left blank."
                                );
                              } else {
                                setImgErrs(""); // Clear error if there are still images
                              } // Update the state manually
                            }}
                            style={{
                              position: "absolute",
                              top: "-5px",
                              right: "-5px",
                              background: "red",
                              color: "#fff",
                              border: "none",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: "12px",
                            }}
                          >
                            &times;
                          </button>
                        </div>
                      ))}
                    </div>
                    {/* {imageList.length > 0 && (
              <button
                onClick={onImageRemoveAll}
                style={{
                  marginTop: '10px',
                  padding: '8px 15px',
                  background: '#007bff',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Remove All
              </button>
            )} */}
                  </div>
                )}
              </ImageUploading>
            </div>
            {imgErrs && <p className="text-danger mt-1"> {imgErrs}</p>}
            <div className="mt-3">
              <label className="text-black fw-bold mb-2">
                Description
                <span className="redErrMsg"> *</span>
              </label>
              <textarea
                value={description}
                onChange={handleChange}
                className="form-control"
                rows="5"
                maxLength={500}
                cols="50"
                placeholder="Provide your description here"
              />
              {DescErr && <p className="text-danger mt-1">{DescErr}</p>}
            </div>
          </div>
        </div>
        <div className="modal-footer pt-3">
          <button
            type="button"
            className="btn btn-light"
            onClick={closeModalPost}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary ms-2"
            onClick={handleSubmit}
            disabled={DescErr || imgErrs || isLoading}
          >
            Add Post
          </button>
        </div>
      </ReactModal>

      <button
        className="btn btn-primary form-control"
        onClick={() => openModalPost(false)}

        // onKeyDown={handleSearch}
      >
        Add New Post
      </button>
    </>
  );
};

export default ModalPostCommunity;
